import { Token } from '@emberswap/emberswap-sdk2/dist/entities'
import React, { FC,useState } from 'react'

import { TokenAsObject } from '../../state/user/reducer'
import { SlideIn } from '../Animation/SlideIn'
import { CodeIcon, IconButton } from '../Icons'
import { Overlay } from '../Overlay'
import { TokenSelectorCustomTokensOverlay } from './TokenSelectorCustomTokensOverlay'

export type TokenSelectorSettingsOverlayProps = {
  onRemoveToken: (payload: Pick<TokenAsObject, 'chainId' | 'address'>) => void
  customTokensMap: Record<string, Token>
}

export const TokenSelectorSettingsOverlay: FC<TokenSelectorSettingsOverlayProps> = ({
  customTokensMap,
  onRemoveToken,
}) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <IconButton
        className="group  w-[24px] h-[24px] flex items-center justify-center"
        onClick={() => {
          setOpen(true)
        }}
      >
        <CodeIcon
          width={20}
          height={20}
          className="duration-1000 ease-in-out group-hover:text-gray-500 text-slate-100"
        />
      </IconButton>
      <SlideIn.FromLeft show={open} onClose={() => setOpen(false)}>
        <Overlay.Content className="!bg-tokenselector gradient-backdrop-blur shadow-lg">
          <Overlay.Header className="!bg-transparent " onClose={() => setOpen(false)} title="Settings" />
          <TokenSelectorCustomTokensOverlay
            customTokensMap={customTokensMap}
            onRemoveToken={onRemoveToken}
          />
        </Overlay.Content>
      </SlideIn.FromLeft>
    </>
  )
}
